var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.goToComment = new function () {
    var self = this;
    this.init = function () {
        this.goToComment();
    }

    this.goToComment = function() {
        $('.js-go-to-comment').click(function() {
            $('html, body').animate({
                scrollTop: $(".extranet-comment-section-comments").offset().top
            }, 800);
        });
    }
} ();






